import axios from "axios";

export const useGetApi = () => {
  return async (apiUrl) => {
    //console.log("I am here:", process.env.REACT_APP_LOCAL_HOST + apiUrl);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_LOCAL_HOST}${apiUrl}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return { error: error.response?.data || "Unknown Error" };
    }
  };
};
